import AMultiFieldSearchInput from 'components/AMultiFieldSearchInput/AMultiFieldSearchInput';
import React, { useEffect, useState, useContext } from 'react';
import APopover from 'views/pages/manage/common/a-popover';
import { regex } from 'views/pages/manage/common/constant/regex/index';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { Card } from '@mui/material';
import { useHistory } from 'react-router-dom';
import Header from './Header'
import ListEditableComponent from './ListEditableRows';
import TableHeader from './TableHeader';
import styles from "./styles.module.scss";
import { createReqObject, createReqObjForRev, initialFilter, grnTypes, grnModule, getGrnDropdownByRole, hardcodeDropdown } from './constant';
import { getFilterCount } from '../onBoardingMaterialIdSetup/constant';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import FilterForm from './FilterForm';
import ALoader from 'views/pages/manage/common/a-loader';
import PoSerialItemListing from './PoSerialItemListing';
import { generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import MessageDialog from '../sapPurchaseOrder/MessageDialog';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { ConfirmationDeleteDialog } from 'views/pages/manage/common/commonComponents';
import moment from "moment";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import AYearPicker from '../../../../common/form-fields-mui/AYearPicker';
import { useSelector } from "react-redux";
import { UserDetails } from 'appContext';
import { failureToast } from '../../../../common/utils/methods/toasterFunctions/function';
import { PermissionContext, RolePermissions } from '../../../../../../../appContext';
import { endpoint, pages } from '../../../../common/constant';


const SapPurchaseGrn = () => {
  const userData = useContext(UserDetails);
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [dropdownData, setDropdownData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState({ ...initialFilter });
  const [filterCount, setFilterCount] = useState(getFilterCount({ ...globalFilter }, ['poNumber', 'docNo']));
  const [poData, setPoData] = useState([])
  const [open, setOpen] = useState(false)
  const [rows, setRows] = useState(null)
  const [headerResp, setHeaderResp] = useState({})
  const [prWarningData, setPOwarningData] = useState()
  const [serialItemList, setSerialItemList] = useState([])
  const [errorResponse, setErrorResponse] = useState(null);
  const [fileData, setFileData] = useState({});
  const [grnType, setGrnType] = useState();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);

  const sapGrnPermission = RolePermissions(
    useContext(PermissionContext),
    pages["sapGrn"]["id"]
  );

  const grnDropdown = getGrnDropdownByRole(sapGrnPermission);

  const isSaveDisabled = (() => {
    if (grnType?.value === '101') {
      return (
        (headerResp?.mvtType?.value !== '102' && !fileData?.attachment) ||
        !headerResp?.deliveryNote ||
        !headerResp?.mvtType?.value
      );
    }

    if (grnType?.value === 'pendingScreen') {
      return !(
        headerResp?.approver === userData?.employeeId &&
        headerResp?.approvalStatus === 'P'
      );
    }

    if (grnType?.value === '102') {
      return (headerResp?.mvtType?.value !== '102')
    }

    return false;
  })();

  const isSaveDisabledForCancel = (() => {
    if (grnType?.value === 'pendingScreen') {
      return !(
        headerResp?.approver === userData?.employeeId ||
        headerResp?.creator === userData?.employeeId
      )
    }
  })();


  const activePlant = useSelector(
    (state) => state.globalData.masterDropdowns
  ).businessArea?.map(({ sapPlantId, sapBusinessArea }) => ({
    label: sapBusinessArea,
    value: sapPlantId,
  }));

  const headerFormHandler = (key, value) => {
    setHeaderResp((prev) => ({ ...prev, [key]: value }))
  }

  const filterFormHandler = (key, value) => {
    setGlobalFilter((prev) => ({ ...prev, [key]: value ?? [] }));
  };

  const searchInputHandler = (inputValue) => {
    const allSapPlants = Array.isArray(activePlant) ? activePlant?.map(p => p?.value) : [];
    // setGlobalFilter({})
    searchHandler({ poNumber: inputValue, processType: grnModule, plant: allSapPlants })
    setFilterCount(0)
    setGlobalFilter({ poNumber: inputValue });
  }

  const grnSearchInputHandler = (inputValue, year) => {
    const allSapPlants = Array.isArray(activePlant) ? activePlant?.map(p => p?.value) : [];
    if (grnType?.value === '102') {
      grnSearchHandler({ docNo: inputValue, year: year, plant: allSapPlants });
    } else if (grnType?.value === 'pendingScreen') {
      grnSearchHandler({ uuid: inputValue, plant: allSapPlants });
    }
    // setFilterCount(0);
    // setGlobalFilter({ docNo: inputValue });
  }

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      grnBasedSearchHandler();
    }
  }

  const grnBasedSearchHandler = () => {
    if (grnType?.value === "101") {
      searchInputHandler(globalFilter?.poNumber,);
    } else if (grnType?.value === "102") {
      grnSearchInputHandler(globalFilter?.docNo, globalFilter?.year);
    } else if (grnType?.value === "pendingScreen") {
      grnSearchInputHandler(globalFilter?.uuid);
    }
  }

  const handleSelectAll = (checked) => {
    const updated = rows.map((row) => ({ ...row, isChecked: checked }));
    setRows(updated);
  };
  const crossHandler = () => {
    setGlobalFilter({ ...initialFilter })
    setRows([]);
    setHeaderResp({});
    setFileData({});
  }

  const searchPoHandler = (reqObj) => {
    searchHandler(reqObj)
    setOpen(false)
  }

  const searchGrnHandler = (reqObj) => {
    grnSearchHandler(reqObj)
    setOpen(false);
  }

  const searchHandler = async (reqObj) => {
    let url = endpoint?.sap?.grn?.poSearch;
    let method = "post";
    try {
      setLoading(true)
      const resp = await fetchAllPostPromisedData(url, reqObj, method);
      if (resp?.code == 200) {
        const isError = resp?.data?.isError == "false" ? false : true;
        const returnData = resp?.data?.return;
        if (isError && returnData?.length) {
          setErrorResponse((prev) => (
            {
              ...prev,
              isCopy: false,
              // docNo: resp?.data?.mt_res?.docNo,
              list: returnData?.map((error, index) => ({
                id: generateRandomId() + index,
                ...error,
              }))
            }
          ))
        }
        if (!reqObj?.poNumber && reqObj?.plant && reqObj?.dateHigh && reqObj?.dateLow) {
          //for listing
          if (!resp?.data?.items || (resp?.data?.items).length < 1) {
            setPOwarningData("No PO found")
          }
          else {
            setPOwarningData("")
            setPoData(resp?.data?.items)
          }
          setOpen(true)

        }
        else {
          const res = resp?.data?.items ? (resp?.data?.items).map((Items, index) => {
            const parsedQuantity = parseFloat(Items?.quantity?.toString()?.trim());

            return {
              ...Items,
              id: index,
              maxQuantity: !isNaN(parsedQuantity) ? parsedQuantity : 0,
              quantity: parseFloat(Items?.quantity) || 0
            }
          }) : [];

          const resHeader = {
            ...(resp?.data?.header),
            docDate: moment(resp?.data?.header?.docDate?.toString()),
            postingDate: new Date()
          }

          //if PO no is present then also store this in state
          if (reqObj?.poNumber && reqObj?.poNumber.trim() !== "") {
            filterFormHandler("poNumber", reqObj?.poNumber);
          }

          setHeaderResp((prev) => ({ ...prev, ...resHeader }));
          setRows(res)
        }
      }
    } catch (error) {
      console.log("error ", error)
    }
    finally {
      setLoading(false)
    }
  }

  const grnSearchHandler = async (reqObj) => {
    const url = endpoint?.sap?.grn?.docSearch;
    const method = "post";

    try {
      setLoading(true);
      const resp = await fetchAllPostPromisedData(url, reqObj, method);

      if (resp?.code !== 200) return;
      const data = resp?.data || {};
      const items = data?.items || [];
      if (!(reqObj?.docNo || reqObj?.uuid) && (reqObj?.poNumber || reqObj?.plant && reqObj?.dateHigh && reqObj?.dateLow)) {
        //for listing
        if (items.length === 0) {
          setPOwarningData("No Document found");
        } else {
          setPOwarningData("");
          setPoData(items);
        }
        // if (grnType?.value === "101") {
        //   searchInputHandler(globalFilter?.poNumber);
        // } else if (grnType?.value === "102") {
        //   grnSearchInputHandler(globalFilter?.docNo, globalFilter?.year);
        // } else if (grnType?.value === "pendingScreen") {
        //   grnSearchInputHandler(globalFilter?.uuid);
        // }
        setOpen(true);
        return;
      }
      else {
        // const formattedRows = items.map((item, index) => ({ ...item, id: index, maxQuantity: parseFloat(item?.quantity?.trim()) }));
        const formattedRows = items?.map((item, index) => {
          const parsedQuantity = parseFloat(item?.quantity?.toString()?.trim());
          return {
            ...item,
            id: index,
            maxQuantity: !isNaN(parsedQuantity) ? parsedQuantity : 0
          };
        });
        const headerObj = data?.header || {};
        if (reqObj?.docNo) {
          filterFormHandler("docNo", reqObj.docNo);
          filterFormHandler("year", reqObj?.year);
        }
        else if (reqObj?.uuid) {
          filterFormHandler("uuid", reqObj.uuid);
        }
        setRows(formattedRows);
        if (Object.keys(headerObj).length > 0) {
          setFileData(headerObj?.attachment ?? "");
          const headerRes = {
            ...headerObj,
            docDate: moment(headerObj?.docDate?.toString()),
            postingDate: new Date()
          };
          setHeaderResp(headerRes);
        }
      }

    } catch (error) {
      console.error("Error during GRN search:", error);
    } finally {
      setLoading(false);
    }
  };

  const createGrnHandler = async () => {
    const reqObj = createReqObject(rows, headerResp, fileData, grnType, activePlant, globalFilter, userData);
    const url = endpoint?.sap?.grn?.create;
    try {
      setLoading(true);
      let method = "post";
      const resp = await fetchAllPostPromisedData(url, reqObj, method);
      if (resp?.code == 200) {
        const isError = resp?.data?.mt_res?.isError == "false" ? false : true;
        const returnData = resp?.data?.mt_res?.return;
        if (isError && returnData?.length) {
          //error response
          setErrorResponse((prev) => (
            {
              ...prev,
              isCopy: false,
              docNo: resp?.data?.mt_res?.docNo,
              list: returnData?.map((error, index) => ({
                id: generateRandomId() + index,
                ...error,
              }))
            }
          ))
        } else {
          // success response
          if (isError !== null && isError === false) {
            let messageText = '';
            if (resp?.data?.mt_res?.uuid) {
              messageText = `Pending GRN created successfully with Unique Id ${resp?.data?.mt_res?.uuid}`;
            } else if (resp?.data?.mt_res?.docNo && grnType?.value == '102') {
              messageText = `GRN reversed for doc number ${resp?.data?.mt_res?.docNo} for year ${resp?.data?.mt_res?.year}`;
            } else if (resp?.data?.mt_res?.docNo && grnType?.value == 'pendingScreen') {
              messageText = `GRN successfully posted/approved for doc number ${resp?.data?.mt_res?.docNo}`;
            }
            crossHandler();
            setFilterCount(0);
            setErrorResponse({
              isCopy: true,
              docNo: resp?.data?.mt_res?.docNo,
              uuid: resp?.data?.mt_res?.uuid,
              list: [
                {
                  id: generateRandomId(),
                  type: "S",
                  messageText: messageText
                },
              ],
            });
          }
        }
        console.log("error res", errorResponse);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  const reversalHandler = async () => {
    const reqObj = createReqObjForRev(rows, headerResp, fileData, grnType, globalFilter?.docNo);
    const url = endpoint?.sap?.grn?.create;
    try {
      setLoading(true);
      let method = "post";
      const resp = await fetchAllPostPromisedData(url, reqObj, method);
      const returnData = resp?.data?.mt_res?.return;
      if (resp?.code == 200) {
        setOpenDeleteDialog(false);
        const isError = resp?.data?.mt_res?.isError == "false" ? false : true;
        if (!isError) {
          crossHandler();
          setFilterCount(0);
          let message = "";
          if (grnType?.value === "102") {
            message = `Doc Number ${resp?.data?.mt_res?.docNo} reversed Successfully.`
          } else if (grnType?.value === "pendingScreen") {
            message = `GRN with Unique ID ${resp?.data?.mt_res?.uuid} reversed Successfully.`
          }
          setErrorResponse({
            isCopy: true,
            list: [
              {
                id: generateRandomId(),
                type: "I",
                messageText: message,
              },
            ],
          });
        }
        else if (returnData?.length) {
          setErrorResponse((prev) => (
            {
              ...prev,
              isCopy: false,
              list: returnData?.map((error, index) => ({
                id: generateRandomId() + index,
                ...error,
              }))
            }
          ))
        }
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  }

  const rowFormHandler = (index, key, value) => {
    setRows(rows => {
      let tempRows = [...rows]
      let tempRowsIndex = rows[index]
      tempRows[index] = { ...tempRowsIndex, [key]: value }
      return tempRows;
    })
  }

  const grnHandler = (value) => {
    console.log('value--', value)
    if (value?.value == '101') {
      console.log('valueGrn--', value)
      setHeaderResp((prev) => ({ ...prev, 'mvtType': hardcodeDropdown?.mvtType?.[0] }))
    }
    else
      setHeaderResp({});
    setGrnType(value)
    setRows([]);
    setFileData({});
    setGlobalFilter({ ...initialFilter });
    setFilterCount(0);

  }

  return <>
    <Card className="mx-3 p-2">
      <div className='d-flex justify-content-between mb-4'>
        <div>
          <BackArrow className='mr-2 cursor' onClick={() => history.goBack()} />
          <h3 className='d-inline'>{grnType?.value === '101' ? "Create GRN" : 'Display GRN'}</h3>
        </div>

        <div style={{ padding: "0 10px", width: "25%" }}>
          <AAutoComplete
            currentValue={grnType}
            handleChange={(value) => {
              grnHandler(value)
            }}
            items={grnDropdown}
            isMulti={false}
            placeholder={"Please Select GRN Type"}
          />
        </div>

        <div
          className="d-flex justify-content-between"
          style={{ columnGap: "10px" }}
        >
          <div style={{ width: "fit-content" }}>
            <AInput
              style={{ width: '320px', height: '30px' }}
              value={
                grnType?.value === "101"
                  ? globalFilter?.poNumber
                  : grnType?.value === "102"
                    ? globalFilter?.docNo
                    : grnType?.value === "pendingScreen"
                      ? globalFilter?.uuid
                      : ""
              }
              placeholder={
                grnType?.value === "101"
                  ? "Enter PO Number"
                  : grnType?.value === "102"
                    ? "Enter Document Number"
                    : grnType?.value === "pendingScreen"
                      ? "Enter Unique ID"
                      : "Enter Value"
              }
              handler={(value) => {
                if (!grnType) return failureToast("Please Select type");
                if (grnType?.value === "101") {
                  filterFormHandler("poNumber", value);
                } else if (grnType?.value === "102") {
                  filterFormHandler("docNo", value);
                } else if (grnType?.value === "pendingScreen") {
                  filterFormHandler("uuid", value);
                }
              }}
              crossIcon={true}
              rightSearchIcon={true}
              searchIconClickHandler={grnBasedSearchHandler}
              crossHandler={crossHandler}
              onKeyDown={onKeyDownHandler}
              regex={grnType?.value === '102' ? regex.numeric : grnType?.value === 'pendingScreen' ? regex?.alphaNumeric : ''}
            />

          </div>
          {grnType?.value === '102' && (
            <div style={{}}>
              <AYearPicker
                value={globalFilter?.year ? moment(globalFilter?.year, 'YYYY') : null}
                handler={(index, val, key) => {
                  filterFormHandler("year", val);
                }}
              />
            </div>)
          }
          <APopover
            buttonComponent={(openPopover, styles) => (
              <AButton
                className="tiny-semi-bold color-dark"
                onClick={openPopover}
                size="xs"
                updatedStyle={{
                  minWidth: "61px",
                  ...(filterCount > 0
                    ? {
                      border: "1px solid #00B0F5",
                      color: "#00B0F5",
                    }
                    : styles),
                }}
              >
                Filter {filterCount > 0 && <>( {filterCount} )</>}
              </AButton>
            )}
            menuComponent={(closePopup) =>
              <FilterForm
                closePopup={closePopup}
                dropdownData={activePlant}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                filterCount={filterCount}
                setFilterCount={setFilterCount}
                filterFormHandler={filterFormHandler}
                searchHandler={grnType?.value === "101" ? searchHandler : grnSearchHandler}
                grnType={grnType}
                userData={userData}
                processType={grnModule}
                crossHandler={crossHandler}
              />
            }
          />
        </div>
      </div>
      {isLoading && <ALoader position='fixed' />}
      {!rows && (<NoRowOverlay message={isLoading ? "Loading..." : null} />)}
      {rows?.length > 0 && (
        <>
          <Header headerRows={headerResp} headerFormHandler={headerFormHandler} filterFormHandler={filterFormHandler} fileData={fileData} setFileData={setFileData} grnType={grnType} setIsDownloaded={setIsDownloaded} />
          <div className={`${styles["table-container"]}`} >
            <TableHeader rows={rows} grnType={grnType} handleSelectAll={handleSelectAll} />
            <ListEditableComponent rows={rows} serialItemList={serialItemList} setSerialItemList={setSerialItemList} rowFormHandler={rowFormHandler} grnType={grnType} />
          </div>

          <div className="d-flex justify-content-start mt-4">
            <AButton
              variant={
                grnType?.value === "101"
                  ? "primary_filled"
                  : grnType?.value === "102"
                    ? "outline_danger"
                    : grnType?.value === "pendingScreen"
                      ? "primary_filled"
                      : "outline_danger"
              }
              onClick={() => {
                if (grnType?.value === "101") {
                  createGrnHandler();
                } else if (grnType?.value === "pendingScreen") {
                  if (!isDownloaded) {
                    failureToast("Please download attachment first before approving");
                    return;
                  }
                  createGrnHandler();
                } else {
                  setOpenDeleteDialog(true);
                }
              }}
              size="xs"
              disabled={isSaveDisabled}
            >
              {grnType?.value === "101"
                ? "Create GRN"
                : grnType?.value === "102"
                  ? "Cancel GRN"
                  : grnType?.value === "pendingScreen"
                    ? "Approval"
                    : "Action"}
            </AButton>

            {grnType?.value === "pendingScreen" && (
              <AButton
                variant="outline_danger"
                onClick={() => { reversalHandler() }}
                size="xs"
                disabled={isSaveDisabledForCancel}
              >
                Cancel Approval
              </AButton>
            )}
          </div>
        </>
      )}
    </Card>
    <PoSerialItemListing
      open={open}
      title={grnType?.value === "101" ? 'PO Listing' : grnType?.value === "102" ? "Document Listing" : grnType?.value === "pendingScreen" ? "Pending Items" : ""}
      setOpen={setOpen}
      rows={poData}
      listingKey={grnType?.value === "101" ? 'poNumber' : grnType?.value === "102" ? "docNo" : grnType?.value === "pendingScreen" ? "uuid" : ""}
      clickSearchHandler={grnType?.value === "101" ? searchPoHandler : searchGrnHandler}
      warningData={prWarningData}
      yearKey={grnType?.value === "102" && 'year'}
      grnType={grnType}
      vendorKey={(grnType?.value === "101" || grnType?.value === 'pendingScreen') && 'vendor'}
      receivingVendorKey={(grnType?.value === "101" || grnType?.value === 'pendingScreen') && 'receivingVendor'}
      activePlant={activePlant}
      globalFilter={globalFilter}
    />

    {errorResponse && !isLoading && (
      <MessageDialog
        rows={errorResponse?.list}
        setErrorResponse={setErrorResponse}
        loading={isLoading}
        errorKey={"type"}
        msgLabelKey={"messageText"}
        prNo={errorResponse?.docNo || errorResponse?.uuid}
        showClipboard={errorResponse?.isCopy}
      />
    )}

    <ConfirmationDeleteDialog
      isOpen={openDeleteDialog}
      setIsOpen={setOpenDeleteDialog}
      onAgree={() => { reversalHandler() }}
      onDisagree={() => setOpenDeleteDialog(false)}
      headerMsg={'Confirm Reverse'}
      msg={`Are you sure you want to reverse whole document?`}
    />

  </>
}
export default SapPurchaseGrn
